import jwt_decode from "jwt-decode";
import axios from "axios";
import API from  "../utils/apiurl";
import { createContext, useEffect, useReducer, useState } from "react"

import AuthReducer from "./AuthReducer"
const INITIAL_STATE = {
    user: null,
    isFetching: false,
    error: false,
}

export const AuthContext = createContext(INITIAL_STATE);

export const AuthContextProvider =  ({children}) => {
    const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);
    const [ user, setUser ] = useState({});
    let decode = null;
    const apiUrl = API;

    const authAxios = axios.create({
        baseURL: apiUrl,
        headers:{
            Authorization: `Bearer ${localStorage.token}`
        }
    })
    if(localStorage.token)
    {
        decode = jwt_decode(localStorage.token);
        
    }
    useEffect(()=>{
        const fetchUser  = async () => {
            const res = await authAxios.get(`${API}/users?userID=${decode?.id}`)
            console.log("***********",res.data);
            setUser(res.data);
        }
        fetchUser();    
    },[]);
    return (
        <AuthContext.Provider 
            value={{
                user: state.user || user, 
                isFetching: state.isFetching, 
                error: state.error,
                dispatch
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}